export class TokenMap {
  tokenName: string;
  tokenValue: string;
}
